/**
 * auth.ts — chamadas tipadas do domínio auth (contrato: schemas/auth.py).
 * Os shapes espelham os tipos gerados em generated/api.d.ts (gate gen:types).
 */

import type { components } from './generated/api'
import { esquecerContaGoogle } from '../lib/google'
import { api } from './http'

export type Sessao = components['schemas']['Sessao']
export type Usuario = components['schemas']['Usuario']

export function login(email: string, senha: string, lembrar = false) {
  return api<Sessao>('/api/v1/auth/login', {
    method: 'POST',
    body: { email, senha, lembrar },
  })
}

export function logout() {
  // Sair é encerrar a sessão AQUI e mandar o Google esquecer a conta. Fica
  // nesta função, e não em cada Shell, porque são duas telas chamando (a
  // comum e a do super admin) e duplicata acaba divergindo.
  esquecerContaGoogle()
  return api<null>('/api/v1/auth/logout', { method: 'POST' })
}

export function me() {
  return api<Sessao>('/api/v1/auth/me')
}

export type Provedores = components['schemas']['Provedores']

/** Como dá para entrar neste ambiente (a tela decide se mostra o Google). */
export function provedores() {
  return api<Provedores>('/api/v1/auth/provedores')
}

/** `credential` é o ID token que o Google Identity Services devolve. */
export function loginGoogle(credential: string) {
  return api<Sessao>('/api/v1/auth/google', {
    method: 'POST',
    body: { credential },
  })
}
